// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxV1_checkbox__iE--+","flag":"CheckboxV1_flag__QUu10","checked":"CheckboxV1_checked__r4w6F"};